
import CheckpointReleaseDatesNotFoundSvgComponent from '../../assets/svg-components/not-found/checkpoint-release-dates';
import './index.scss';

export default function CheckpointReleaseDatesNotfound() {
  return (
    <>
      <div className="new-not-found-wrap">
        <div className="new-not-found-wrap__details">
          {/* <img
            src="/images/page-not-found/checkpoint-release-dates.svg"
            className="not-found-image img-fluid not-found-image-checkpoint-release-dates"
          /> */}
          <div className="not-found-image not-found-image-checkpoint-release-dates">
            <CheckpointReleaseDatesNotFoundSvgComponent />
          </div>
          <p className="no-data-found-text">No vendor has been found. Please create a new vendor to map the release date at the location level.</p>
        </div>
      </div>
    </>
  );
}
